var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('VerticalMenu'),_c('v-main',{staticClass:"mx-auto",staticStyle:{"background-color":"#f0f2f5","height":"100vh"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }